<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    size="md"
    title="Create new user"
    title-tag="h5"
    cancel-title="Cancel"
    id="idBranchDetailNewUserModal"
    cancel-variant="outline-primary"
    :ok-title="this.$store.state.user ? 'Update' : 'Create'"
    :ok-disabled="firstName === null || lastName === null || userEmail === null"
    @shown="focusFirstInput"
    @show="onShow"
    @hidden="clearData"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <label class="required" for="idFirstName">First Name</label>
        <b-form-input
          size="sm"
          id="idFirstName"
          ref="firstInput"
          trim
          v-model="firstName"
        ></b-form-input>
      </b-row>
      <b-row>
        <label class="required" for="idLastName">Last Name</label>
        <b-form-input
          size="sm"
          id="idLastName"
          trim
          v-model="lastName"
        ></b-form-input>
      </b-row>
      <b-row>
        <label class="required" for="idEmail">E-mail</label>
        <b-form-input
          size="sm"
          id="idEmail"
          trim
          v-model="userEmail"
        ></b-form-input>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      firstName: null,
      lastName: null,
      userEmail: null,
    };
  },
  methods: {
    focusFirstInput() {
      this.$refs.firstInput.focus();
    },
    onShow() {
      if (this.$store.state.user) {
        this.id = this.$store.state.user.id;
        this.firstName = this.$store.state.user.firstName;
        this.lastName = this.$store.state.user.lastName;
        this.userEmail = this.$store.state.user["e-Mail"];
      }
    },
    onOk() {
      if (this.$store.state.user) {
        this.$emit("updateUser", {
          id: this.$store.state.user.id,
          firstName: this.firstName,
          lastName: this.lastName,
          userEmail: this.userEmail,
        });
      } else {
        this.$emit("newUser", {
          firstName: this.firstName,
          lastName: this.lastName,
          userEmail: this.userEmail,
        });
      }
    },
    clearData() {
      this.$store.commit("SET_USER_TO_EDIT", null);
      this.firstName = null;
      this.lastName = null;
      this.userEmail = null;
    },
  },
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin: 0.8rem 0;
}
</style>